import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'activities',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.scss']
})
export class ActivitiesComponent implements OnInit {

 
  constructor() {
    
  }

  ngOnInit(): void { }


}
